import { render, staticRenderFns } from "./OptionPropertyInstructions.vue?vue&type=template&id=1f2b1454"
import script from "./OptionPropertyInstructions.vue?vue&type=script&lang=js"
export * from "./OptionPropertyInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports